var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 7.44772H11.107V15.3766C11.107 15.4798 11.1914 15.5641 11.2945 15.5641H12.7008C12.8039 15.5641 12.8883 15.4798 12.8883 15.3766V7.44772H14.625C14.782 7.44772 14.8687 7.26725 14.7727 7.14538L12.1477 3.82194C12.1301 3.79953 12.1077 3.78141 12.0821 3.76894C12.0565 3.75648 12.0285 3.75 12 3.75C11.9715 3.75 11.9435 3.75648 11.9179 3.76894C11.8923 3.78141 11.8699 3.79953 11.8523 3.82194L9.22734 7.14304C9.13125 7.26725 9.21797 7.44772 9.375 7.44772ZM20.5781 14.6735H19.1719C19.0688 14.6735 18.9844 14.7579 18.9844 14.861V18.4704H5.01562V14.861C5.01562 14.7579 4.93125 14.6735 4.82812 14.6735H3.42188C3.31875 14.6735 3.23438 14.7579 3.23438 14.861V19.5016C3.23438 19.9165 3.56953 20.2516 3.98438 20.2516H20.0156C20.4305 20.2516 20.7656 19.9165 20.7656 19.5016V14.861C20.7656 14.7579 20.6812 14.6735 20.5781 14.6735Z",
    fill: "#17B67C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b93f2472a0b990369190ecd341bb49c1.svg";
export { ForwardRef as ReactComponent };